// The "soft surface" language the agentic home and onboarding share.
// The app's own card radius and light shadows, as the Projects gallery's cards take, on a warm-gray page gradient.
export const SOFT_SURFACE_RADIUS = "3xl";

export const SOFT_SURFACE_SHADOW = "sm";

export const SOFT_SURFACE_HOVER_SHADOW = "md";

/** Layered gradient applied to the full page background. */
export const SOFT_PAGE_BACKGROUND =
  "linear-gradient(0deg, rgba(171, 178, 186, 0.2) 0%, rgba(200, 193, 197, 0.2) 38.4%, rgba(211, 203, 202, 0.2) 55.5%, rgba(215, 210, 209, 0.2) 100%), var(--chakra-colors-base-background)";

// Display typography shared by the agentic home greeting and the onboarding page
// title so the two surfaces stay in sync.
export const AGENTIC_DISPLAY_TITLE_PROPS = {
  fontSize: "40px",
  lineHeight: "48px",
  fontWeight: "medium",
  letterSpacing: "-0.3px",
  color: "text.tertiary",
} as const;

export const AGENTIC_DISPLAY_SUBTITLE_PROPS = {
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: "normal",
  color: "text.disabled",
} as const;
